const customer = {
    name: 'Energy Transfer',

    emails: {
        pods: '',
        corrosion: ''
    }
}

export default customer;